import { useEffect } from 'react';

import { usePathname } from 'expo-router';

import { RunningExperiments, useExperiments } from 'state/experiments';
import { routes } from 'utils/routing';

export const useEnableCheckoutV2Experiment = () => {
  const { variant, logExposure } = useExperiments();
  const pathname = usePathname();

  useEffect(() => {
    if (pathname === routes.cartCheckout || pathname === routes.cartPayment) {
      logExposure(RunningExperiments.CheckoutV2);
    }
  }, [pathname, logExposure]);

  return variant(RunningExperiments.CheckoutV2, 'treatment', {
    skipExposureLogging: true,
  });
};
